var render = function render(_c,_vm){return _c('div',{staticClass:"info-list"},_vm._l((_vm.props.infoListContent),function(item,i){return _c('div',{key:i,staticClass:"info-list__item"},[_c('p',{staticClass:"info-list__content"},[_c('span',{staticClass:"info-list__content--bold"},[_vm._v(_vm._s(item.bold))]),_vm._v(": "),_c('span',{staticClass:"info-list__content--light"},[_vm._v(_vm._s(item.light))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }